import { Skeleton } from './skelton.component';
import { templateTypes, blockTemplateTypes } from '../templates/templateTypes';
import { BLOCKS } from './skelton.constants';
import { SearchSkeleton } from '../../search/skeleton/search.skeleton.component';

const SKELETONS = {
  generic: {
    type: Skeleton,
    rows: [
      templateTypes.Hero,
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.CardM,
      },
    ],
  },
  program: {
    type: Skeleton,
    rows: [
      templateTypes.Jumbotron,
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.CardM,
      },
    ],
  },
  'folder-portrait': {
    type: Skeleton,
    rows: [
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.Banner,
        count: 1,
        hideTitle: true,
      },
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.Portrait,
        count: 9,
      },
    ],
  },
  'folder-card': {
    type: Skeleton,
    rows: [
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.Banner,
        count: 1,
        hideTitle: true,
      },
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.CardM,
      },
    ],
  },
  'folder-sport': {
    type: Skeleton,
    rows: [
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.Banner,
        count: 1,
        hideTitle: true,
      },
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.FlatRectangle,
        count: 7,
        hideTitle: true,
      },
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.CardM,
        count: 6,
      },
    ],
  },
  epg: {
    type: Skeleton,
    rows: [blockTemplateTypes.HorizontalEpg],
  },
  search: {
    type: SearchSkeleton,
    rows: [
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.CardL,
      },
      {
        blockTemplate: blockTemplateTypes.List,
        itemTemplate: templateTypes.Portrait,
      },
    ],
  },
};

export const getSkeletonByConfig = config => {
  if (!config) {
    return null;
  }

  if (Array.isArray(config.skeleton)) {
    return {
      type: Skeleton,
      rows: config.skeleton.map(name =>
        BLOCKS[name]
          ? name
          : {
              blockTemplate: blockTemplateTypes.List,
              itemTemplate: name,
            },
      ),
    };
  }

  return (config.preset && SKELETONS[config.preset]) || null;
};
